import { render } from "./PreviewTab.vue?vue&type=template&id=08751f2b&scoped=true&ts=true"
import script from "./PreviewTab.vue?vue&type=script&lang=ts"
export * from "./PreviewTab.vue?vue&type=script&lang=ts"

import "./PreviewTab.vue?vue&type=style&index=0&id=08751f2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08751f2b"]])

export default __exports__